import React from "react";
import { Box } from "@material-ui/core";

type Props = {
  active: boolean;
};

export const Section: React.FC<Props> = (props) => {
  return props.active ? (
    <Box
      flexGrow={1}
      component="section"
      display="flex"
      flexDirection="column"
      overflow="hidden"
    >
      {props.children}
    </Box>
  ) : null;
};
